<template>
  <v-card
    class="mx-auto parent-list-overflow rounded-card card-shadow"
    height="450"
    max-height="450"
  >
    <v-card-title class="headline font-weight-bold pa-5">
      Cotações pendentes
    </v-card-title>
    <v-card-text class="text--primary list-overflow">
      <div v-if="loading">
        <px-circular-loading/>
      </div>
      <div>
        <v-list class="mt-3" v-if="!loading && cotacoes.length">
        <template v-for="cotacao in cotacoes">
          <v-list-item link :to="path(cotacao)" :key="cotacao.id">
            <v-list-item-content>
              <v-row dense no-gutters>
                <v-col cols="12" sm="8">
                  <px-situacao-solicitacao-icon :situacao="cotacao.situacaoSolicitacaoResposta"/>
                  {{ cotacao.nomeCliente }}
                </v-col>
                <v-col cols="12" sm="4" class="text-center">
                  {{ quantidadeProdutos(cotacao) }}
                  <div>
                    <small>produto(s)</small>
                  </div>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
          <v-divider :key="`div-${cotacao.id}`"/>
        </template>
      </v-list>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { TipoSolicitacao } from 'px-business-components';
import CotacaoService from '@/modules/cotacoes/cotacoes-listagem-service';

export default {
  data() {
    return {
      loading: false,
      cotacoes: [],
    };
  },
  computed: {
    path() {
      return (item) => {
        if (item.tipoSolicitacaoResposta === TipoSolicitacao.keys.COTACAO.key) {
          return `cotacao/${item.id}`;
        }
        return `cotacao-conjunta/${item.id}`;
      };
    },
    quantidadeProdutos() {
      return (item) => {
        if (item.tipoSolicitacaoResposta === TipoSolicitacao.keys.COTACAO.key) {
          return item.cotacao.quantidadeProdutos;
        }
        return item.cotacaoConjunta.quantidadeProdutos;
      };
    },
  },
  methods: {
    getCotacoes() {
      this.loading = true;
      CotacaoService.getCotacoesList({
        query: 'situacao in ("NAO_RESPONDIDA") and (situacaoCotacao = "ABERTA" or situacaoCotacao = "CARRINHO" or situacaoCotacao = "COMPRA") order by createdIn desc',
      })
        .then(({ data }) => {
          this.cotacoes = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getCotacoes();
  },
};
</script>

<style scoped>
.parent-list-overflow {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.list-overflow {
  width: 100%;
  height: 395px;
  max-height: 395px;
  padding-right: 17px;
  overflow-y: scroll;
  box-sizing: content-box;
}
</style>
